import { hexToPptxColor } from "../export/pptxUnits.js";
export function emptyTableData(columns = 3, rows = 2) {
    return {
        columns: Array.from({ length: columns }, (_, i) => `Colonna ${i + 1}`),
        rows: Array.from({ length: rows }, () => Array.from({ length: columns }, () => "")),
    };
}
export function normalizeTableData(data) {
    const columns = data.columns.map((c) => String(c ?? "").trim());
    const colCount = Math.max(columns.length, 1);
    const safeColumns = columns.length > 0 ? columns : Array.from({ length: colCount }, (_, i) => `Colonna ${i + 1}`);
    const rows = data.rows.map((row) => {
        const cells = row.map((c) => String(c ?? ""));
        while (cells.length < safeColumns.length)
            cells.push("");
        return cells.slice(0, safeColumns.length);
    });
    return { columns: safeColumns, rows };
}
export function getLayerTable(layer) {
    const raw = layer.style?.table;
    if (!raw || typeof raw !== "object")
        return emptyTableData();
    const o = raw;
    return normalizeTableData({
        columns: Array.isArray(o.columns) ? o.columns.map(String) : [],
        rows: Array.isArray(o.rows)
            ? o.rows.map((r) => (Array.isArray(r) ? r.map(String) : []))
            : [],
    });
}
export function setLayerTable(layer, table) {
    return {
        ...layer,
        style: { ...layer.style, table: normalizeTableData(table) },
    };
}
export function setTableCell(data, rowIndex, colIndex, value) {
    const next = normalizeTableData(data);
    if (rowIndex < 0) {
        if (colIndex < 0 || colIndex >= next.columns.length)
            return next;
        next.columns[colIndex] = value;
        return next;
    }
    if (rowIndex >= next.rows.length || colIndex < 0 || colIndex >= next.columns.length)
        return next;
    next.rows[rowIndex][colIndex] = value;
    return next;
}
export function addTableColumn(data, label = "Nuova colonna") {
    const next = normalizeTableData(data);
    next.columns.push(label);
    next.rows = next.rows.map((row) => [...row, ""]);
    return next;
}
export function removeTableColumn(data, colIndex) {
    const next = normalizeTableData(data);
    if (next.columns.length <= 1)
        return next;
    next.columns.splice(colIndex, 1);
    next.rows = next.rows.map((row) => row.filter((_, i) => i !== colIndex));
    return next;
}
export function addTableRow(data) {
    const next = normalizeTableData(data);
    next.rows.push(Array.from({ length: next.columns.length }, () => ""));
    return next;
}
export function removeTableRow(data, rowIndex) {
    const next = normalizeTableData(data);
    if (rowIndex < 0 || rowIndex >= next.rows.length)
        return next;
    next.rows.splice(rowIndex, 1);
    return next;
}
/** Matrix with header row first — for export pipelines. */
export function tableMatrixWithHeader(data) {
    const normalized = normalizeTableData(data);
    return [normalized.columns, ...normalized.rows];
}
export function buildPptxTableRows(data, theme) {
    const normalized = normalizeTableData(data);
    const headerRow = normalized.columns.map((col) => ({
        text: col,
        options: {
            bold: true,
            fill: { color: hexToPptxColor(theme.palette.muted) },
            color: hexToPptxColor(theme.palette.text),
            align: "left",
        },
    }));
    const bodyRows = normalized.rows.map((row) => normalized.columns.map((_, ci) => ({
        text: row[ci] ?? "",
        options: {
            color: hexToPptxColor(theme.palette.text),
            align: "left",
        },
    })));
    return [headerRow, ...bodyRows];
}
export function tableLayerFromData(table, partial) {
    return {
        type: "table",
        x: 0.52,
        y: 0.18,
        w: 0.4,
        h: 0.64,
        z: partial?.z ?? 30,
        rotation: 0,
        content: "",
        style: { table: normalizeTableData(table) },
        ...partial,
    };
}
